<template>
	<div class="video-desc">
		（選填）若您與我們分享貴組享四分鐘的故事歷程影片（故事影片時間長度建議為 3-5 分鐘）。
		<br>*可由簡報轉存成影片檔。
		<br>
		<br>我們會將貴組的故事影片分享於：
		<br><a href="https://www.youtube.com/dfctaiwan" target="_blank">DFC 臺灣 YouTube 頻道</a>：你們的故事影片將會於該屆的故事播放清單中，並有機會媒合至：
		<br>各式分享舞台：電台、電視、短講、展覽、記者會等分享形式，讓更多人看見你們的故事。
		<br>
		<br>HERO Talks世界公民教育論壇暨頒獎典禮：每年邀請世界各地的英雄們與臺灣小英雄齊聚一堂，舉辦一場又一場充滿愛的力量的演講，將愛與希望散播到全世界！
		<br>
		<br>DFC 全球年會：由挑戰獎組別代表參與，與來自全球75個國家師生，彼此交流這一年來改變世界的故事。
		<br>
		<br>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.video-desc {
	font-size: 14px;
	padding-left: 2em;
}
</style>